import request from '@/axios'

/**
 * @Description: 获取产品类型及 套餐型号 列表
 */
export function getProductPackageList(){
  return request({
    method:'get',
    url:'/api/product/getProductPackageList',
  })
}

/**
 * @Description: 条件查询 产品激活提交记录
 */
export function getProductVoList(data){
  return request({
    method: 'post',
    url: '/api/product/getProductVoList',
    data: data
  })
}

/**
 * @Description: 修改流程状态（流程管理操作栏的取消、提交按钮使用）
 */
export function updateProductFlowStatus(data){
  return request({
    method: 'post',
    url: '/api/product/updateProductFlowStatus',
    data: data
  })
}

/**
 * @Description: 提交产品激活申请
 */
export function registerProductNew(data){
  return request({
    method: 'post',
    url: '/api/product/registerProduct',
    data: data
  })
}

/**
 * @Description: 修改产品激活记录信息
 */
export function updateProduct(data){
  return request({
    method: 'post',
    url: '/api/product/updateProduct',
    data: data
  })
}

/**
 * @Description: 删除产品激活申请记录
 */
export function deleteProductRegister(data){
  return request({
    method: 'get',
    url: '/api/product/deleteProductRegister',
    params: data
  })
}

/**
 * @Description: 下载证书
 */
export function downloadLicenses(data){
  return request({
    method: 'get',
    url: '/api/product/downloadLicenses',
    params: data
  })
}
